import BasePieChart from "../../sisu/chart/BasePieChart.sisu";

const NeoPieChart = (props)=>{
    return <BasePieChart {...props}>
        {props.children}
    </BasePieChart>
}

export default NeoPieChart;